export default {
  name: 'scene-card',
  props: {
    card: {
      type: Object,
      required: true
    }
  }
};